<div class="grid">
  <div class="grid__unit s-visible ml-hidden">
    <app-mobile-menu></app-mobile-menu>
    <app-resetform
      [buttonStyle]="'button button--link'"
      (resetFilter)="onResetFilter()"
    ></app-resetform>
  </div>

  <div class="grid__unit s-hidden ml-visible ml-4-12 l-4-12 xl-3-12">
    <app-filter-container
      id="filterOne"
      [filters]="filters$"
      [items]="deals$"
      (filterUpdated)="filterUpdated($event)"
      (resetFilter)="onResetFilter()"
    ></app-filter-container>
  </div>
  <div class="grid__unit s-4-4 m-12-12 ml-8-12 l-8-12 xl-9-12">
    <app-results-summary
      class="filterPage__header"
      [items]="deals$"
    ></app-results-summary>
    <app-tile-container [items]="deals$"></app-tile-container>
  </div>
</div>
